@value padding-size: 16px;
@value total-padding: 32px; /* 2 * padding-size */

.content-container {
    position: relative;
    display: flex;
    text-align: left;
    height: 100%;
    width: 100%;
}

.thumbnail-container {
    position: relative;
    aspect-ratio: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.thumbnail-container > :first-child {
    position: absolute;
    width: calc(100% - total-padding);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: padding-size;
}

.thumbnail-container--full > :first-child {
    width: 100%;
}

.thumbnail-container--full {
    padding: 0;
}

.text-container {
    composes: text-container from './cue-card.module.css';
}

.bookmark-icon-container {
    composes: bookmark-icon-container from './cue-card.module.css';
}

/* When there's no thumbnail, add extra margin to text container to space the bookmark icon out */
.bookmark-icon-container:first-child ~ .text-container {
    margin-top: 16px;
}

.complete {
    composes: complete from './cue-card.module.css';
}

.minimize-button {
    composes: minimize-button from './cue-card.module.css';
}

.minimize-button:hover,
.minimize-button:focus {
    color: var(--icon-secondary-dk);
}

/* When there's a minimize button, add a margin to title to avoid collision */
.minimize-button ~ .text-container > :first-child {
    margin-right: 12px;
}
